import { useSearchContext } from 'contexts/SearchContext';
import { useFiltersListContext } from '../contexts/FiltersListContext';
import { isValidFilter } from '../filters';


export const useListsByTags = () => {
  const { data } = useSearchContext();
  const { state: filters } = useFiltersListContext();
  
	if (data) {
		const tagLists = Object.values(data.reduce((acc, { company, tags, ...list }) => {
      tags.forEach(tag => {
        const { id, name, colorScheme } = tag;
        
        if (isValidFilter(filters?.tags, tag.id)) {
          const row = acc[id] ?? {id, name, colorScheme, lists: [], companies: { }};

          if (isValidFilter(filters?.companies, company.id)) {
            acc[id] = {...row, lists: [...row.lists, {...list, company } ], companies: { ...row.companies, [company.id]: true} };
          }
        }
      })
			return acc;
		}, {}));

    const lists = tagLists.map((row: any) => ({...row, companies: Object.keys(row.companies).length}));
    return lists.sort((a, b) => (a.name < b.name ? -1 : 1));
	}
	return data;
};


